import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Stepper.scss';

class Stepper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 1,
    };
  }

  handleClick = nr => {
    this.setState({ activeStep: nr });
    this.props.activeStep(nr);
  }
  handleNextButton = () => {
    this.setState({ activeStep: this.state.activeStep === this.props.stepsNum ? this.state.activeStep : this.state.activeStep + 1 });
  }
  handlePrevButton = () => {
    this.setState({ activeStep: this.state.activeStep === 1 ? this.state.activeStep : this.state.activeStep - 1 });
  }

  renderStepsLine = arr => {
    return arr.map(
      (item, index) => {
        return (
          <div
            key={index}
            className={item === this.state.activeStep ? 'stepsline stepsline-active' : 'stepsline'}
            onClick={() => this.handleClick(item)}
          >
            <svg
              viewBox="0 0 24 24"
              className={item <= this.state.activeStep ? 'svg-style svg-style-active stepsline step' : 'svg-style stepsline step'}
            >
              <circle cx="12" cy="12" r="10"></circle>
              <text x="12" y="16" textAnchor="middle" fontSize="12" fill="#fff">{item}</text>
            </svg>
            <div className={'stepsline desc' + ' ' + (item === this.state.activeStep ? 'active-text' : '')}>{this.props.stepsDescription[index]}</div>
            {
              index !== this.props.stepsNum - 1 ?
                <div className={(item <= this.state.activeStep ? 'stepsline hline hline-active' : 'stepsline hline') + ' ' + (item === this.state.activeStep ? 'longline' : '')} />
                : null
            }
          </div>
        );
      },
    );
  }

  render() {
    const stepsNum = this.props.stepsNum;
    // creates an array of numbers equal to steps number:
    const stepsArr = Array.from(Array(stepsNum).keys()).map(x => x + 1)

    return (
      <div className='stepper-container'>
        <div className='title'>
          Stepper
        </div>
        {this.renderStepsLine(stepsArr)}
        <div>
          <button className={this.state.activeStep === 1 ? 'buttn-disabled' : 'buttn'} onClick={this.handlePrevButton}>Poprzedni</button>
          <button className={this.state.activeStep === this.props.stepsNum ? 'buttn-disabled' : 'buttn'} onClick={this.handleNextButton}>Następny</button>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Stepper);



// WEBPACK FOOTER //
// src/routes/administrator/components/stepper/Stepper.js